import { useParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@lombok/ui';
import { PageHeader } from '@/components/PageHeader';
import { BackLink, DetailRow } from '@/components/DetailRow';
import { FORM_COLUMN } from '@/components/layout';
import { StatusPill } from '@/components/StatusPill';
import { QueryState } from '@/components/QueryState';
import { useCustomer } from '@/data/hooks';
import { TERMS_LABELS_ES } from '@/features/admin/labels';
import { CreditSummary } from '@/features/customer/CustomerDetailPage';

const BASE = '/app/distributor/subclientes';

/**
 * One sub-account in the distributor portal: its balance and credit and the account's basic data, read only.
 * The API answers 403 for a customer that is not linked to the distributor.
 */
export function SubaccountDetailPage() {
  const { id } = useParams<{ id: string }>();
  const query = useCustomer(id);

  return (
    <div className={`flex flex-col gap-6 ${FORM_COLUMN}`}>
      <div className="flex flex-col gap-2">
        <BackLink to={BASE}>Subclientes</BackLink>
        <PageHeader title={query.data?.name ?? 'Subcliente'} description="Cuenta, crédito y saldo." />
      </div>

      <QueryState
        isLoading={query.isLoading}
        isError={query.isError}
        error={query.error}
        onRetry={() => void query.refetch()}
        loadingLabel="Cargando subcliente…"
      >
        {query.data ? (
          <div className="flex flex-col gap-6">
            <CreditSummary customer={query.data} />
            <Card>
              <CardHeader>
                <CardTitle>Información de la cuenta</CardTitle>
              </CardHeader>
              <CardContent className="pt-0">
                <dl className="flex flex-col">
                  <DetailRow label="Nombre">{query.data.name}</DetailRow>
                  <DetailRow label="RIF">{query.data.rif}</DetailRow>
                  <DetailRow label="Estado">
                    <StatusPill kind="account" value={query.data.status} />
                  </DetailRow>
                  <DetailRow label="Términos de pago">{TERMS_LABELS_ES[query.data.paymentTerms]}</DetailRow>
                </dl>
              </CardContent>
            </Card>
          </div>
        ) : null}
      </QueryState>
    </div>
  );
}
